// 业务工具方法写在此文件中
import moment from 'moment'
import numeral from 'numeral'

/**
 * 将 list 转换为 object
 * @param {*} list array
 * @param {*} labelName
 * @param {*} valueName
 */
export const listToObj = function(
  list,
  labelName = 'label',
  valueName = 'value',
) {
  let temp = {}
  list.forEach(element => {
    temp[element[valueName]] = element[labelName]
  })
  return temp
}

/**
 * 将 object 转为 list，object的格式为 {key: {key1: '', key2: ''}}
 * @param {*} obj
 * @param {*} labelName list 中 label的key名字
 * @param {*} valueName list 中 value的key名字
 * @param {*} objLabelName object 中 label的key名字
 */
export const objToList = function(
  obj,
  labelName = 'label',
  valueName = 'value',
  objLabelName = 'label',
) {
  let temp = []
  for (let key in obj) {
    temp.push({ [labelName]: obj[key][objLabelName], [valueName]: key })
  }
  return temp
}

/**
 * 将 object 转为 {'label': 'color'}对象
 * @param {*} obj
 * @param {*} labelName obj中label的keyName
 * @param {*} colorName obj中color的keyName
 */
export const objToLabelColorObj = function(
  obj,
  labelName = 'label',
  colorName = 'color',
) {
  let temp = {}
  for (let key in obj) {
    const crt = obj[key]
    temp[crt[labelName]] = crt[colorName]
  }
  return temp
}

/**
 * 获取form未通过校验项list
 * @param {object} fieldsError
 * @param {string} formName
 */
export const getFieldsErrorList = function(fieldsError, formName) {
  return Object.keys(fieldsError)
    .filter(fieldError => fieldsError[fieldError])
    .map(fieldError => {
      return {
        key: fieldError,
        msg: fieldsError[fieldError].join(', '),
        formName: formName,
      }
    })
}

/**
 * 限制两位小数的输入
 * @param {*} value
 */
export const handleInputFloat_2 = function(value) {
  const regFloat_2 = /^\d*(\.?\d{0,2})/g
  return (value.match(regFloat_2) && value.match(regFloat_2)[0]) || ''
}

/**
 * 限制输入正整数,且第一位非0
 * @param {*} value
 */
export const handleInputPositiveInt = function(value) {
  const reg1st_not0 = /^[1-9]\d*/g
  return (value.match(reg1st_not0) && value.match(reg1st_not0)[0]) || ''
}

/**
 * 滚动至某项未通过校验处
 * @param {*} fieldKey <label></label>中for的值
 */
export const scrollToField = function(fieldKey) {
  const labelNode = document.querySelector(`label[for="${fieldKey}"]`)
  if (labelNode) {
    labelNode.scrollIntoView(true)
  }
}

/**
 * 将未知是否赋值的rangeDate值用分开的 startDateName 和 endDateName 传给param
 * @param {*} param
 * @param {*} dateRange
 * @param {*} startDateName
 * @param {*} endDateName
 */
export const formatParamDate = function(
  param,
  dateRange,
  startDateName = 'startTime',
  endDateName = 'endTime',
  format = 'YYYY-MM-DD',
) {
  if (dateRange && dateRange.length === 2) {
    param[startDateName] =
      typeof dateRange[0] == 'string'
        ? dateRange[0]
        : moment(dateRange[0]).format(format)
    param[endDateName] =
      typeof dateRange[1] == 'string'
        ? dateRange[1]
        : moment(dateRange[1]).format(format)
  } else {
    param[startDateName] = ''
    param[endDateName] = ''
  }
  return param
}
export const formatDate = function(
  param,
  dateRange,
  startDateName = 'startTime',
  endDateName = 'endTime',
  format = 'YYYY-MM-DD 00:00:00',
) {
  if (dateRange && dateRange.length === 2) {
    param[startDateName] =
      typeof dateRange[0] == 'string'
        ? dateRange[0]
        : moment(dateRange[0]).format(format)
    param[endDateName] =
      typeof dateRange[1] == 'string'
        ? dateRange[1]
        : moment(dateRange[1]).format(format)
  } else {
    param[startDateName] = ''
    param[endDateName] = ''
  }
  return param
}
/*
 * get请求拼接参数
 * @param url url地址
 * @param data json格式的请求参数
 * @returns {string}
 */
export const urlParam = (url, data) => {
  let paramsStr = ''
  for (let k in data) {
    let value = data[k] !== undefined ? data[k] : ''
    paramsStr += '&' + k + '=' + encodeURIComponent(value)
  }

  const params = paramsStr ? paramsStr.substring(1) : ''

  return (url += url.indexOf('?') < 0 ? '?' : '&') + params
}

/**
 * 获得rules
 * @param {*} message
 * @param {*} required
 * @param {*} otherRules
 */
export const getRules = function(
  message = '请输入',
  required = true,
  otherRules = [],
) {
  return [{ required, message }, ...otherRules]
}

export const getTrimVal = val => {
  return typeof val === 'string' ? val.trim() : val
}

/**
 * array转换为Object
 * @param {*} array
 * @param {*} keyName
 * @param {*} valueName
 */
export const arrayToObject = (array, keyName, valueName) => {
  let obj = {}
  array.forEach(item => {
    obj[item[keyName]] = item[valueName]
  })
  return obj
}

/**
 * 获取不同环境下的host
 */
export const getEnvHost = () => {
  return process.env.NODE_ENV === 'development'
    ? '//10.103.250.131:10008/credit'
    : '/credit'
}

export const getLogoUrl = () => {
  const stamp = new Date().getTime()
  return `${getEnvHost()}/logo?_=${stamp}`
}
export const resetAmount = num => {
  return numeral(num).format('0.00')
}
export const formatAmount = num => {
  return numeral(num).format('0,0.00')
}

export const timestamp2date = timestamp => {
  //将时间戳转换成时间格式
  // d.cTime = 1539083829787
  let date = new Date(timestamp)
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  let day = date.getDate()
  month = month < 10 ? '0' + month : month
  day = day < 10 ? '0' + day : day
  return year + '-' + month + '-' + day
}
